import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Select, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'title', label: 'Title', required: true },
  { key: 'subtitle', label: 'Subtitle' },
  { key: 'content', label: 'Content', textarea: true, rows: 10, required: true },
  { key: 'summary', label: 'Summary', textarea: true },
];

export const ContentEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'content' });
  const content = queryResult?.data?.data;

  const initialValues = React.useMemo(() => {
    if (!content) return formProps.initialValues;
    return {
      ...content,
      effectiveDate: content.effectiveDate ? dayjs(content.effectiveDate) : undefined,
      expiryDate: content.expiryDate ? dayjs(content.expiryDate) : undefined,
    };
  }, [content, formProps.initialValues]);

  return (
    <Edit resource="content" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        initialValues={initialValues}
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, LANG_FIELDS, queryResult?.data?.data?.translations),
          })
        }
      >
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Format" name="format">
          <Select>
            <Select.Option value="markdown">Markdown</Select.Option>
            <Select.Option value="html">HTML</Select.Option>
            <Select.Option value="json">JSON</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Effective Date" name="effectiveDate">
          <DatePicker style={{ width: '100%' }} showTime />
        </Form.Item>
        <Form.Item label="Expiry Date" name="expiryDate">
          <DatePicker style={{ width: '100%' }} showTime />
        </Form.Item>
      </Form>
    </Edit>
  );
};
